export default __webpack_public_path__ + "static/media/FreshAirOn.48927f9e.svg";